import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcAnchoringupFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "25",
    fill: "none",
    viewBox: "0 0 24 25",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.778 20.56a1.1 1.1 0 0 1-1.556 0L12 15.336l-5.222 5.222a1.1 1.1 0 1 1-1.556-1.556l6-6a1.1 1.1 0 0 1 1.556 0l6 6a1.1 1.1 0 0 1 0 1.556",
    clipRule: "evenodd",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.778 12.56a1.1 1.1 0 0 1-1.556 0L12 7.336l-5.222 5.222a1.1 1.1 0 1 1-1.556-1.555l6-6a1.1 1.1 0 0 1 1.556 0l6 6a1.1 1.1 0 0 1 0 1.555",
    clipRule: "evenodd"
  }));
}
var IcAnchoringupFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcAnchoringupFill));

export { IcAnchoringupFill as I };
